module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "chapter-4-fv.-endeavour-fy369"
    }
  }, [_c('h1', [_vm._v("Chapter 4"), _c('br'), _vm._v(" Fv. Endeavour Fy369")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    staticStyle: {
      "text-align": "center",
      "margin-top": "25px",
      "margin-bottom": "25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.15879in",
      "height": "2.76815in",
      "filter": "grayscale(100%)"
    },
    attrs: {
      "alt": "",
      "src": "media/file5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Endeavour prior to launch")])]), _vm._v(" "), _c('p', [_vm._v("Endeavour prior to launch")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("The fishing vessel "), _c('em', [_vm._v("Endeavour")]), _vm._v(" (Reg. No FY369) was built for my father, Fernley Soady, by Arthur Collings at his boat yard on East Looe quay and launched in April 1947 (The Looe Harbour Commissioners workshop now occupies the site of the old boat yard.) The Endeavour was 35ft 3ins long with a beam of 10ft 6ins, constructed with full length, fitted (as distinct from caulked) planks of Columbian Pine on English Oak frames.")]), _vm._v(" "), _c('p', [_vm._v("The main propulsion was by a 30hp Lister diesel main engine and a 16hp Lister diesel auxiliary (wing) engine. The propeller of the ‘wing’ engine exited the vessel’s hull under the port quarter and was used primarily when ‘gear’ was being worked from the starboard side of the vessel. Most fishing vessels at that time worked their ‘gear’ (nets, crab pots, long lines etc,) from the starboard side, hence there was far less chance of the ‘gear’ fouling a propeller situated under the port side.")]), _vm._v(" "), _c('p', [_vm._v("A ten gallon tank on the starboard side supplied diesel fuel for the 16hp Lister and a twenty gallon tank on the port side supplied fuel for the 30 hp Lister. The tanks were filled through port and starboard deck fillers situated fore side of the wheel house.")]), _c('br'), _vm._v(" "), _c('p', [_c('em', [_vm._v("(25 years after the boat was constructed, these fuel tanks were to pose a serious problem when found not to be large enough to supply fuel to the more modern engines that were installed in the Endeavour during the summer of 1969. This lack of fuel storage capacity sometimes required the tanks to be topped up at sea, should the Endeavour be farther than 35 miles from Looe.)")])]), _c('br'), _vm._v(" "), _c('p', [_vm._v("(Every trip to Falmouth Bay and beyond, during each future winter mackerel season meant that someone would have to climb on the foredeck with 5 gallon cans of diesel and a funnel to top up both the port and starboard fuel tanks. An unenviable task at any time. Not only did it require a sheer balancing act in poor weather, but there was always the danger of the crew member going over the side into the sea!)")]), _vm._v(" "), _c('p', [_vm._v("My association with the "), _c('em', [_vm._v("Endeavour")]), _vm._v(" began early one evening in November 1946, when I saw that the keel had been laid down for my father’s new fishing boat in the Arthur Collings’ boatyard, where my motor boat "), _c('em', [_vm._v("Seahorse")]), _vm._v(" was built some 7 years later in 1954.")]), _vm._v(" "), _c('p', [_vm._v("From that day, as an inquisitive 9 year old schoolboy, I often visited the boatyard to ‘inspect’ the progress of the building operation. Then came the day of a once-in-a-lifetime exhilarating experience. Accompanied by my friend, Alan (Jack) Harris and with my father’s permission, Jack and I were allowed to sit in the forward cabin when the "), _c('em', [_vm._v("Endeavour")]), _vm._v(" was launched over the quayside at East Looe into the river at high water at 8.10pm on Tuesday 22 April 1947.")]), _vm._v(" "), _c('p', [_vm._v("Unfortunately, there was a sting in the tail for me and Jack. We were both members of the 1st East Looe Methodist Cub Pack and I had explained to the Scout Master, Mr Daniels, that the "), _c('em', [_vm._v("Endeavour")]), _vm._v(" was being launched on Tuesday, the same evening as the weekly Cub meeting and Jack and I were allowed to be aboard at the launch, so could we be excused attending the Cub meeting.")]), _vm._v(" "), _c('p', [_vm._v("Mr Daniels said that attending the Cubs was more important and he was intransigent in refusing us permission. He added that if we failed to attend the meeting, both Jack and I would be expelled from the Cub Pack. We decided not to tell our parents about the impasse that we had with Mr Daniels until after the launch of the "), _c('em', [_vm._v("Endeavour")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    staticStyle: {
      "text-align": "center",
      "margin-top": "25px",
      "margin-bottom": "25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.97815in",
      "height": "3.02611in",
      "filter": "grayscale(100%)"
    },
    attrs: {
      "alt": "",
      "src": "media/file6.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Launching of the `Iolanthe`")])]), _vm._v(" "), _c('p', [_vm._v("Launching of the Iolanthe")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    staticStyle: {
      "text-align": "center",
      "margin-top": "25px",
      "margin-bottom": "25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.06123in",
      "height": "2.5661in",
      "filter": "grayscale(100%)"
    },
    attrs: {
      "alt": "",
      "src": "media/file7.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Looe Scouts")])]), _vm._v(" "), _c('p', [_vm._v("Looe, 1st Methodist Scout Group. (I am the 3rd boy from the left, top row. `Jack Harris is 4th boy next to me.)")]), _vm._v(" "), _c('p', [_c('strong', [_c('em', [_c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    staticStyle: {
      "text-align": "center",
      "margin-top": "25px",
      "margin-bottom": "25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.20751in",
      "height": "4.27742in",
      "filter": "grayscale(100%)"
    },
    attrs: {
      "alt": "",
      "src": "media/file8.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("001[2]")])]), _vm._v(" "), _c('p', [_vm._v("Alan (Jack) Harris")]), _vm._v(" "), _c('p', [_vm._v("When the next Tuesday came following the week of the launch, I reluctantly had to tell my mother the story and that I wasn’t going to Cubs again because Jack Harris and I had been expelled. To this day I have little knowledge of the events which followed our expulsion from the Cubs, but apparently my mother had contacted Mrs Harris.")]), _vm._v(" "), _c('p', [_vm._v("I can only speculate on what followed on from their meeting. What I do know is that after being confronted by two extremely irate mothers; Mr Daniels capitulated and reconsidered his decision. Jack and I were reinstated in the Cub Pack forthwith. I carried on ‘scouting’ until the age of 15.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f48c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch009.vue
// module id = 87
// module chunks = 0